import service from "@/utils/axios-v2";
import request from "@/utils/request";

/**
 * Integration Tab Api
 */
// getQboIntegrationHasConnected
export function getQboIntegrationHasConnected(params) {
  return service({
    url: "/fleet/qbo-integration/has/connected",
    method: "get",
    params: params,
  });
}
// getQboIntegrationConnectedUrl
export function getQboIntegrationConnectedUrl(params) {
  return service({
    url: "/fleet/qbo-integration/connect/url",
    method: "get",
    params: params,
  });
}
// getQboIntegrationConnected
export function getQboIntegrationConnected(params) {
  return service({
    url: "/fleet/qbo-integration/connected",
    method: "get",
    params: params,
  });
}
// cancelQboIntegration
export function cancelQboIntegration(data) {
  return service({
    url: "/fleet/qbo-integration/cancel",
    method: "DELETE",
    data,
  });
}

/**
 * Map pay items Tab Api
 */
// getQboPayItemList
export function getQboPayItemList(params) {
  return service({
    url: "/fleet/qbo-item/list",
    method: "get",
    params: params,
  });
}
// getQboPayItemServiceList
export function getQboPayItemServiceList(params) {
  return service({
    url: "/fleet/qbo-item/service/list",
    method: "get",
    params: params,
  });
}
// updateQboPayItem
export function updateQboPayItem(data) {
  return service({
    url: "/fleet/qbo-item/update",
    method: "POST",
    data,
  });
}
// batchUpdateQboPayItem
export function batchUpdateQboPayItem(data) {
  return request({
    url: "/fleet/qbo-item/update/batch",
    method: "POST",
    data,
  });
}

export function sendQboCustomer(data) {
  return service({
    url: '/fleet/qbo-customer/send',
    method: 'post',
    data
  })
}

export function qboInvoiceSend(data) {
  return request({
    url: '/fleet/qbo-invoice/send',
    method: 'post',
    data
  })
}



export function qboIsCheck(data) {
  return service({
    url: '/fleet/qbo-invoice/check',
    method: 'post',
    data
  })
}
/**
 * Customer Tab Api
 */
// listQboCustomer
export function listQboCustomer() {
  return service({
    url: "/fleet/qbo-customer/customer/list",
    method: "GET",
  });
}
// listCommandCustomer
export function listCommandCustomer(params) {
  return service({
    url: "/fleet/qbo-customer/list",
    method: "GET",
    params:params
  });
}
// updateLinkCustomerWithQbo
export function updateLinkCustomerWithQbo(data) {
  return service({
    url: "/fleet/qbo-customer/update",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// autoSyncCustomerWithQbo
export function autoSyncCustomerWithQbo(data) {
  return service({
    url: "/fleet/qbo-customer/sync",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}


// headers: {
//   "portal-token": true,
// },
